import React from 'react';
import ReactDOM from 'react-dom';
import "./assets/css/fonts.css";
import './index.css';
import './assets/theme/theme.scss';
import "./assets/css/r2devprosStyle.css";
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { LayoutSimple } from './layouts/LayoutSimple';
import Alert from 'react-s-alert';
import AlertContentTemplate from '../src/utils/alertComponent'


//RM 
import { Provider } from 'react-redux';
import store from './redux/store';

ReactDOM.render(
    <React.Fragment>
        <Provider store={store}>
            <LayoutSimple />
            <Alert contentTemplate={AlertContentTemplate} stack={{ limit: 3 }} />
        </Provider>
    </React.Fragment>

, document.querySelector('#root'));